<template>
  <div>
    <div class="d-flex align-items-center">
      <div
        class="lang-selector-color-bullet"
        :style="{
          backgroundColor: parsedHexColor
        }"
      />
      <div v-if="option.title">
        <div>{{ option.title }}</div>
      </div>
    </div>
    <div
      v-if="option.description"
      class="f6"
    >
      {{ option.description }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomSelectorDotOption',
  props: {
    option: {
      default: null
    },
    hexColor: {
      default: 'color',
      type: String
    }
  },
  computed: {
    parsedHexColor() {
      if (this.hexColor && this.hexColor.indexOf('#') !== -1) {
        return this.hexColor;
      }
      return `#${this.hexColor}`;
    }
  }
};
</script>

<style lang="scss">
.lang-selector-color-bullet {
  width: 10px;
  height: 10px;
  margin-right: 10px;
  border-radius: 100%;
  flex-shrink: 0;
  background-color: #ccc;
}
</style>
